var APP_INIT_REQUEST = 'APP_INIT_REQUEST';
var APP_INIT_RECEIVE = 'APP_INIT_RECEIVE';
var APP_SET_MAIN_CONTENT_FULL_HEIGHT = 'APP_SET_MAIN_CONTENT_FULL_HEIGHT';
var APP_USER_LOAD_BALANCE_SUCCESS = 'APP_USER_LOAD_BALANCE_SUCCESS';
var APP_REMOVE_ALERT = 'APP_REMOVE_ALERT';
var APP_URL_INIT = '/common/init/index';
var APP_URL_SEARCH_REGIONS = '/geo/default/search-region';
var APP_URL_SEARCH_CITIES = '/geo/default/search-city';
var APP_URL_LOAD_REGIONS = '/geo/default/load-regions';
var APP_URL_LOAD_CITIES = '/geo/default/load-cities';
var APP_USER_LOAD_BALANCE_URL = '/user/default/load-balance';
var APP_LOAD_DATA_LAYER_URL = '/common/init/load-data-layer';
var TITLE = 'Telegram Collaborator';
var REDUCER_GLOBAL_NAME = 'global';
var ERROR_MESSAGE_DEFAULT = 'Error, our specialists already know about it and take measures';
var DEFAULT_TIMEOUT = 300;
var DEFAULT_DEBOUNCE_TIME = 300;
var DEFAULT_DEBOUNCE_TIME_MD = 2000;
export { APP_INIT_REQUEST, APP_INIT_RECEIVE, APP_SET_MAIN_CONTENT_FULL_HEIGHT, APP_USER_LOAD_BALANCE_SUCCESS, APP_REMOVE_ALERT, APP_URL_INIT, APP_URL_SEARCH_REGIONS, APP_URL_SEARCH_CITIES, APP_URL_LOAD_REGIONS, APP_URL_LOAD_CITIES, APP_USER_LOAD_BALANCE_URL, APP_LOAD_DATA_LAYER_URL, TITLE, REDUCER_GLOBAL_NAME, ERROR_MESSAGE_DEFAULT, DEFAULT_TIMEOUT, DEFAULT_DEBOUNCE_TIME, DEFAULT_DEBOUNCE_TIME_MD };